import { TRIGGER_CONNECTION_NAME, TypedActorNode } from "./_Base";
import { NodeParamsConfig } from "../utils/params/ParamsConfig";
import { ActorConnectionPoint, ActorConnectionPointType } from "../utils/io/connections/Actor";
import { ActorType } from "../../poly/registers/nodes/types/Actor";
export var OnTickActorNodeOuput = /* @__PURE__ */ ((OnTickActorNodeOuput2) => {
  OnTickActorNodeOuput2["TIME"] = "time";
  OnTickActorNodeOuput2["DELTA"] = "delta";
  return OnTickActorNodeOuput2;
})(OnTickActorNodeOuput || {});
class OnTickActorParamsConfig extends NodeParamsConfig {
}
const ParamsConfig = new OnTickActorParamsConfig();
export class OnTickActorNode extends TypedActorNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return ActorType.ON_TICK;
  }
  initializeNode() {
    this.io.outputs.setNamedOutputConnectionPoints([
      new ActorConnectionPoint(TRIGGER_CONNECTION_NAME, ActorConnectionPointType.TRIGGER),
      new ActorConnectionPoint("time" /* TIME */, ActorConnectionPointType.FLOAT),
      new ActorConnectionPoint("delta" /* DELTA */, ActorConnectionPointType.FLOAT)
    ]);
  }
  outputValue(context, outputName) {
    switch (outputName) {
      case "time" /* TIME */: {
        return this.scene().timeController.time();
      }
      case "delta" /* DELTA */: {
        return this.scene().timeController.timeDelta();
      }
    }
  }
}
